import React from 'react';
import Form from 'react-bootstrap/Form';

const CheckboxForm = (props) => {
  const checkboxLabel = props.label;
  const checkboxId = props.id;
  const checkboxIndex = props.index
  const handleClick = props.onClick;

  return(
    <Form.Check
      sronly={true}
      custom
      type='checkbox'
      label={checkboxLabel}
      id={checkboxId}
      onClick={(event)=>{
        handleClick(checkboxIndex, event.currentTarget.checked)
      }}
    />
  )
}

export default CheckboxForm;